var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "div",
            {
              staticClass: "operations",
              staticStyle: { "margin-bottom": "5px" }
            },
            [
              _c("div", { staticClass: "triggers" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "query",
                          disabled: !_vm.isEdit,
                          type: "primary"
                        },
                        on: { click: _vm.toQuery }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "upload",
                          disabled: !_vm.isEdit,
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            _vm.cloudFile.visible = true
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("FileHistory.Upload")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "delete",
                          disabled: !_vm.isEdit,
                          type: "danger"
                        },
                        on: { click: _vm.remove }
                      },
                      [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          no: "invoiceDownloadLabel",
                          disabled: !_vm.isEdit,
                          type: "primary"
                        },
                        on: { click: _vm.download }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("Invoice.invoice_invoiceDownloadLabel"))
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]
          ),
          _c(
            "div",
            { staticClass: "grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                staticStyle: {
                  "flex-grow": "1",
                  height: "100%",
                  width: "100%"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    return (_vm.gridApi = params.api)
                  }
                }
              })
            ],
            1
          ),
          _c("cargo-cloud-file-upload", {
            attrs: {
              visible: _vm.cloudFile.visible,
              job: _vm.cloudFile.job,
              lob: _vm.cloudFile.lob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cloudFile, "visible", $event)
              },
              uploadDone: _vm.toQuery
            }
          }),
          _vm.isEdit
            ? _c("drop-uploader", {
                ref: "dropUploader",
                attrs: {
                  action: _vm.URL.common.uploadStorage,
                  "upload-params": _vm.uploadParams
                },
                on: { "upload-end": _vm.uploadEnd }
              })
            : _vm._e()
        ],
        1
      ),
      _c("pre-view-file-dialog", {
        attrs: {
          "v-if": _vm.previewFileData.visible,
          no: "preview",
          title: _vm.$t("FileHistory.preview"),
          visible: _vm.previewFileData.visible,
          file: _vm.previewFileData.file,
          "can-maximize": true
        },
        on: { close: _vm.closePreviewDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }